import { render, staticRenderFns } from "./UpsellModal.vue?vue&type=template&id=38a0bd1d&scoped=true&"
import script from "./UpsellModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./UpsellModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a0bd1d",
  null
  
)

export default component.exports